"use client";
import BackBtn from "./components/BackBtn";
import { utilities } from "../design1/PropertyPage1";
import { PropertyUtilities2 } from "../../constants/utilitiesIcons";
import { Angle } from "./Rent2";
import ImageGrid from "./components/ImageGrid";
import { mockProperties } from "../../constants/mockProperties";
// import { Form } from "../design1/components/ContactMandate";
import React from "react";
import Example from "../design1/components/Map";
// import { MemberType } from "src/types";
import { mockRules } from "../design1/ShortletPage1";
// import Link from "next/link";
import { members } from "../design1/components";
// import CardGrid from "../../CardGrid";
// import { CardVariant2 } from "./components/CardVariant2";
import { ParentCard } from "../design1/PropertyPage1";
import { useParams } from "next/navigation";
import { findPropertyById } from "../../constants/mockProperties";
import { useState } from "react";
import { m, AnimatePresence, LazyMotion, domAnimation } from "framer-motion";
import { PropertyCard } from "./Rent2";
import { mockDesc, SideItem2 } from "./Sale2";
import { ShowMoreText } from "../design1/About1";
import { generateSliderImages } from "../design3/components/PropertyCarousel2";
const Shortlet2 = () => {
  const images = generateSliderImages(mockProperties.forRent[0].images);
  const search = useParams();
  const { id } = search;
  const toNum = parseInt(id as string);
  const property = findPropertyById(toNum)!;
  return (
    <section>
      <div className="wrapper pb-10 pt-5">
        <BackBtn dark />
        <PropertyCard
          quote={property.quote}
          title={property.title}
          price={property.price}
          propertyId="6454545"
          address={property.address}
          beforePrice={property?.beforePrice}
          discount={property.discount}
          quotePrice={property.quotePrice}
          priceType={property.priceType}
        />
        <div className="second">
          <ImageGrid
            images={[
              {
                url: "https://www.youtube.com/watch?v=m3E72ZJ54_k",
                type: "video",
              },
              ...images,
            ]}
          />
        </div>

        <div className="grid-container mt-8">
          <div className="first flex flex-col gap-4">
            {" "}
            <ParentCard variant header="Property Brief">
              <ShowMoreText maxLength={300} text={mockDesc} />

              {/* Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nam
              dolorum aperiam odio incidunt fugiat distinctio velit inventore
              aspernatur placeat voluptatum possimus hic, consequatur quos esse!
              Architecto fugit inventore corporis, illum, repellendus ipsam
              eveniet, culpa necessitatibus praesentium ab ipsa tenetur pariatur
              at id! Tempore, enim, doloremque laboriosam repellendus soluta
              optio iure adipisci at molestias voluptate eos consequuntur? Sed
              quia dolorem sint architecto. Deserunt ipsum, adipisci fugiat
              placeat, nam, aliquid veniam vitae voluptatibus deleniti pariatur
              voluptas unde alias molestias aperiam ea earum impedit nesciunt!
              Animi mollitia nostrum, odio voluptates ut consequuntur ex
              expedita dolor quasi eius illum, qui eligendi impedit reiciendis!
              Numquam! */}
            </ParentCard>
            <ParentCard header="Rules">
              <PropertyUtilities2 list="rules" selectedItems={mockRules} />
            </ParentCard>
            <ParentCard variant header="New Occupants">
              <KeyValueDisplay money data={newOccupants} />
            </ParentCard>
            <ParentCard variant header="Renewal Occupants">
              <KeyValueDisplay money data={renewalOccupants} />
            </ParentCard>
            <ParentCard variant header="Facilities">
              <PropertyUtilities2 selectedItems={utilities} />
            </ParentCard>
            <ParentCard variant header="Booking Information">
              <KeyValueDisplay data={bookingInformation} />
            </ParentCard>
            <Accordion
              data={{
                title: "Terms & Conditions",
                questions: [
                  {
                    question: "Refund Policy",
                    answer: "You can request a refund within 7 days.",
                  },
                  {
                    question: "Property Facility",
                    answer: "Facilities include WiFi, Pool, and Gym.",
                  },
                  {
                    question: "Other Rules",
                    answer: "No smoking inside the premises.",
                  },
                ],
              }}
            />
            <ParentCard variant header="Location">
              <Example coordinates={[6.4913408, 3.391488]} />
            </ParentCard>
          </div>
          <SideItem2 properties={mockProperties.forRent} member={members[0]} />
        </div>
      </div>
    </section>
  );
};
export default Shortlet2;

interface KeyValueDisplayProps {
  data: Record<string, string | number>;
  money?: boolean;
}

const KeyValueDisplay: React.FC<KeyValueDisplayProps> = ({ data, money }) => {
  return (
    <div className="flex flex-col max-w-[600px] gap-2">
      {Object.entries(data).map(([key, value]) => (
        <div key={key} className="flex justify-between gap-14 pb-2">
          <span className="font-medium flex-1">{key}</span>
          <span className="font-semibold text-left flex-1">
            {money ? `₦${Number(value).toLocaleString()}` : value}
          </span>
        </div>
      ))}
    </div>
  );
};

// const propertyDetails: Record<string, string | number> = {
//   "Property Title": "Obolongo Estate",
//   Category: "Residential",
//   Preference: "Newly Built",
//   "Unit Type": "Block Of Flat",
//   "Unit Sub Type": "Flat",
//   "Total Area": "4300sqm",
//   Bathroom: 20,
//   Bedroom: 20,
//   Toilet: 20,
//   "Unit Name/Number": 20,
//   "Total Unit": 20,
//   "Available Unit": 20,
//   "Total Views": 20,
//   Bookmarks: 20,
//   "Added Date": "20/02/2025",
//   "Last Updated": "20/02/2025",
// };

// const initialPaymentDetails: Record<string, number> = {
//   "Inspection Fee": 3000000,
//   "Rent Fee": 3000000,
//   "Service Charge": 3000000,
//   "Refundable Caution Fee": 3000000,
//   "Non-Refundable Legal Fee": 3000000,
//   "Non-Refundable Agency Fee": 3000000,
//   "Other Fee": 3000000,
//   "Total Package": 3000000,
// };

// const renewalTenantDetails: Record<string, number> = {
//   "Rent Fee": 3000000,
//   "Service Charge": 3000000,
//   "Other Fee": 3000000,
//   "Total Package": 3000000,
// };

// const StaffContact: React.FC<MemberType> = ({
//   name,
//   role,
//   phone,
//   image,
//   email,
// }) => {
//   return (
//     <div className="flex p-6 border-b flex-col items-center gap-2">
//       <img
//         src={image}
//         className="image block size-[6rem] rounded-full"
//         alt={name}
//       />
//       <h4 className="text-secondary-main font-semibold">{name}</h4>
//       <h6>{role}</h6>
//       <Link href={`tel:${phone}`} className="flex gap-2 items-center">
//         <CallIcon /> {phone}
//       </Link>
//       <Link href={`mailto:${email}`} className="flex gap-2 items-center">
//         <MessageIcon /> {email}
//       </Link>
//     </div>
//   );
// };

// const CallIcon = () => {
//   return (
//     <svg
//       width="25"
//       height="24"
//       viewBox="0 0 25 24"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M14.5871 2.34385C16.5934 2.55525 18.4675 3.44512 19.8995 4.8663C21.3314 6.28747 22.2353 8.15481 22.4618 10.1595M14.5871 6.28121C15.5552 6.47211 16.4436 6.9496 17.1369 7.65171C17.8303 8.35382 18.2965 9.24813 18.4752 10.2186M22.4126 17.0302V19.9832C22.4137 20.2574 22.3576 20.5287 22.2477 20.7799C22.1379 21.0311 21.9768 21.2566 21.7748 21.4419C21.5728 21.6272 21.3343 21.7683 21.0746 21.8561C20.8149 21.944 20.5398 21.9766 20.2667 21.9519C17.2378 21.6224 14.3284 20.5874 11.7719 18.93C9.39356 17.4187 7.37714 15.4023 5.86585 13.0239C4.20263 10.4558 3.16739 7.53221 2.84393 4.48971C2.81933 4.2175 2.85168 3.94316 2.93892 3.68415C3.02615 3.42513 3.16637 3.18712 3.35063 2.98526C3.5349 2.78341 3.75917 2.62213 4.00918 2.5117C4.25919 2.40127 4.52945 2.3441 4.80276 2.34385H7.75578C8.23349 2.33914 8.69661 2.50831 9.05882 2.81981C9.42102 3.1313 9.6576 3.56388 9.72446 4.03691C9.84877 4.98201 10.0799 5.90994 10.4135 6.80291C10.5459 7.15522 10.5746 7.53812 10.4961 7.90623C10.4176 8.27434 10.2352 8.61223 9.97055 8.87986L8.72044 10.13C10.1217 12.5943 12.1621 14.6348 14.6265 16.036L15.8766 14.7859C16.1442 14.5213 16.4821 14.3389 16.8502 14.2604C17.2183 14.1819 17.6012 14.2105 17.9535 14.343C18.8465 14.6765 19.7744 14.9077 20.7195 15.032C21.1977 15.0994 21.6344 15.3403 21.9466 15.7087C22.2587 16.0771 22.4246 16.5475 22.4126 17.0302Z"
//         stroke="#2F364B"
//         stroke-width="1.47651"
//         stroke-linecap="round"
//         stroke-linejoin="round"
//       />
//     </svg>
//   );
// };

// const MessageIcon = () => {
//   return (
//     <svg
//       width="24"
//       height="25"
//       viewBox="0 0 24 25"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M2.94922 7.86028C2.94922 7.33816 3.15663 6.83741 3.52583 6.46821C3.89503 6.09902 4.39577 5.8916 4.9179 5.8916H18.6987C19.2208 5.8916 19.7215 6.09902 20.0907 6.46821C20.4599 6.83741 20.6673 7.33816 20.6673 7.86028V17.7037C20.6673 18.2258 20.4599 18.7265 20.0907 19.0957C19.7215 19.4649 19.2208 19.6724 18.6987 19.6724H4.9179C4.39577 19.6724 3.89503 19.4649 3.52583 19.0957C3.15663 18.7265 2.94922 18.2258 2.94922 17.7037V7.86028Z"
//         stroke="#2F364B"
//         stroke-width="1.47651"
//         stroke-linecap="round"
//         stroke-linejoin="round"
//       />
//       <path
//         d="M2.94922 7.85645L11.8083 13.7625L20.6673 7.85645"
//         stroke="#2F364B"
//         stroke-width="1.47651"
//         stroke-linecap="round"
//         stroke-linejoin="round"
//       />
//     </svg>
//   );
// };

interface AccordionProps {
  data: {
    title: string;
    questions: { question: string; answer: string }[];
  };
}
const Accordion: React.FC<AccordionProps> = ({ data }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div className="w-full bg-white p-4 border rounded-2xl shadow-lg">
      <h2 className="text-xl font-semibold mb-4">{data.title}</h2>
      {data.questions.map((item, index) => (
        <div key={index} className=" py-2 last:border-none">
          <button
            onClick={() => toggleAccordion(index)}
            className="w-full text-left transition-all text-secondary-main duration-500 flex justify-between items-center"
          >
            {item.question}
            <span
              className={`text-themeColor transform transition-all duration-500 text-2xl ${
                index === openIndex ? "rotate-[180deg]" : "rotate-0"
              }`}
            >
              <Angle />
            </span>
          </button>
          <LazyMotion features={domAnimation}>
            <AnimatePresence>
              {openIndex === index && (
                <m.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  transition={{
                    duration: 0.3,
                    ease: "easeInOut",
                  }}
                  exit={{ opacity: 0, height: 0 }}
                  className="pl-4 text-secondary-main"
                >
                  {item.answer}
                </m.div>
              )}
            </AnimatePresence>
          </LazyMotion>
        </div>
      ))}
    </div>
  );
};

const newOccupants: Record<string, string | number> = {
  "Price Per Night": 3000000,
  "Refundable Caution Fee": 3000000,
  "First Payment": 3000000,
  "Total Payment": 3000000,
};

const renewalOccupants: Record<string, string | number> = {
  "Cost Per Night": 3000000,
  "Subsequential Payment": 3000000,
};

export const bookingInformation: Record<string, string | number> = {
  "Property Title": "Obolongo Estate",
  "Booking Type": "Per Day",
  "Guest Capacity": 5,
  "Guest Allowed": 7,
  "Maximum Booking Duration": "1 Week",
  "Check In": "2:30 pm",
  "Check Out": "2:30 pm",
};
